<template>
  <div class="strengths-and-gaps-list">
    <div class="header">
      <img src="../assets/positive-icon.svg" alt="positive" />
      <h3>Strengths</h3>
    </div>
    <div>
      <ul class="strengths-list">
        <li
          v-for="rating in topStrengthRatings"
          :key="rating.strength.name"
          data-test="strengths-list-item"
        >
          {{ rating.strength.name }}
        </li>
      </ul>
    </div>
    <div class="header">
      <img src="../assets/negative-icon.svg" alt="negative" />
      <h3>Gaps</h3>
    </div>
    <div>
      <ul class="gaps-list">
        <li v-for="rating in gapRatings" :key="rating.strength.name" data-test="gaps-list-item">
          {{ rating.strength.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { StrengthItemRatingApiModel } from "../api-models";

const props = defineProps<{ ratings: StrengthItemRatingApiModel[] }>();

const topStrengthRatings = computed(() => {
  if (!props.ratings) return [];

  return props.ratings.slice(0, 5);
});

const gapRatings = computed(() => {
  if (!props.ratings) return [];

  return props.ratings.slice(-5);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../styles/bootstrap/variables.less";

.strengths-and-gaps-list {
  .header {
    border-bottom: 1px solid @dark-background-color;
    padding-bottom: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: start;
    align-items: center;

    img {
      height: 24px;
    }

    h3 {
      font-size: 18px;
      margin: 0 10px;
    }
  }

  ul {
    li {
      text-align: left;
      white-space: nowrap;
    }
  }

  .strengths-list li {
    font-size: 16px;
  }

  .gaps-list li {
    font-size: 13px;
  }
}
</style>
